module.exports = __webpack_public_path__ + "img/a62c751.jpg";